export interface Template {
  id: string;
  name: string;
  type: 'email' | 'statement';
  outputType?: 'email' | 'pdf'; // Output format
  subject?: string; // for emails
  content: string; // HTML content
  isDefault: boolean;
  category?: string[];
  variables: string[]; // list of variables used
  thumbnail?: string;
  lastModified: string;
  createdAt: string;
  createdBy: string;
  // PDF-specific settings
  pdfSettings?: {
    logo?: {
      url: string;
      position: 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';
      width: number; // in pixels
      height: number; // in pixels
    };
    pageLayout: {
      size: 'A4' | 'Letter' | 'Legal';
      orientation: 'portrait' | 'landscape';
      margins: {
        top: number;
        right: number;
        bottom: number;
        left: number;
      };
    };
    header?: {
      enabled: boolean;
      content: string;
      height: number;
    };
    footer?: {
      enabled: boolean;
      content: string;
      height: number;
    };
    styling: {
      fontFamily: string;
      fontSize: number;
      primaryColor: string;
      secondaryColor: string;
      lineSpacing: number;
    };
  };
}

export interface TemplateVariable {
  key: string;
  label: string;
  category: 'customer' | 'company' | 'account' | 'system';
  example: string;
}

export const templateVariables: TemplateVariable[] = [
  // Customer
  { key: '{{customer.name}}', label: 'Customer Name', category: 'customer', example: 'John Doe' },
  { key: '{{customer.email}}', label: 'Customer Email', category: 'customer', example: 'john@example.com' },
  { key: '{{customer.phone}}', label: 'Customer Phone', category: 'customer', example: '(555) 123-4567' },
  { key: '{{customer.accountNumber}}', label: 'Account Number', category: 'customer', example: 'ACC-12345' },
  
  // Company
  { key: '{{company.name}}', label: 'Company Name', category: 'company', example: 'Acme Corp' },
  { key: '{{company.address}}', label: 'Company Address', category: 'company', example: '123 Main St' },
  { key: '{{company.phone}}', label: 'Company Phone', category: 'company', example: '(555) 987-6543' },
  { key: '{{company.email}}', label: 'Company Email', category: 'company', example: 'info@acme.com' },
  
  // Account
  { key: '{{account.balance}}', label: 'Account Balance', category: 'account', example: '$1,234.56' },
  { key: '{{account.dueDate}}', label: 'Due Date', category: 'account', example: '12/31/2023' },
  { key: '{{account.invoiceNumber}}', label: 'Invoice Number', category: 'account', example: 'INV-001' },
  { key: '{{account.paymentAmount}}', label: 'Payment Amount', category: 'account', example: '$500.00' },
  
  // System
  { key: '{{system.date}}', label: 'Current Date', category: 'system', example: '01/15/2024' },
  { key: '{{system.userName}}', label: 'User Name', category: 'system', example: 'Jane Smith' },
  { key: '{{system.time}}', label: 'Current Time', category: 'system', example: '2:30 PM' },
];
